import apiRequest from '../../utils/api.request';
import config from '../../config.json';
import { logError } from '../../utils/utils'
import getHeaderFromParams from '../index';
import { parseQueryString } from '../../utils/utils'
import lodash from 'lodash'

export const srBookingAllowedCall = async () => {
  const url = config.covid_vacc_base_url + "booking/v3/booking_allowed/";
  const params = parseQueryString()
  const reqData = getHeaderFromParams(params)
  try {
    const data = await apiRequest(
      url,
      reqData,
      true
    )
    return new Promise((resolve) => {
      resolve({ ...data, apiResponseCode: 'success' })
    })
  } catch (error) {
    logError(error)
    return new Promise((resolve, reject) => {
      reject(error)
    })
  }
}

export const srGetHospitalList = async (requestData) => {
  try {
    const url = config.covid_vacc_base_url + "booking/v2/centre_list/";
    const params = parseQueryString()
    const reqData = {
      ...getHeaderFromParams(params),
      ...requestData
    }

    const data = await apiRequest(
      url,
      reqData,
      true
    )
    if (data.apiResponse === 'failed' || data.statusCode !== 200) {
      return new Promise((resolve) => {
        resolve({ ...data, apiResponseCode: 'failure' })
      })
    }
    return new Promise((resolve) => {
      resolve({ ...data, apiResponseCode: 'success' })
    })
  } catch (error) {
    logError(error)
    return new Promise((resolve) => {
      resolve({ apiResponseCode: 'failure' })
    })
  }
}

export const srGetSlotsForDate = async (requestData) => {
  try {
    const url = `${config.covid_vacc_base_url}booking/v2/get_slots_for_date/`;
    const params = parseQueryString()
    const reqData = {
      ...getHeaderFromParams(params),
      ...requestData
    }

    const data = await apiRequest(
      url,
      reqData,
      true
    )
    if (data.apiResponse === 'failed' || data.statusCode !== 200) {
      return new Promise((resolve) => {
        resolve({ ...data, apiResponseCode: 'failure' })
      })
    }
    return new Promise((resolve) => {
      resolve({ ...data, apiResponseCode: 'success' })
    })
  } catch (error) {
    logError(error)
    return new Promise((resolve) => {
      resolve({ apiResponseCode: 'failure' })
    })
  }
}

export const srGetSlots = async (requestData) => {
  try {
    const url = `${config.covid_vacc_base_url}booking/v2/get_all_slots/`
    const params = parseQueryString()
    const reqData = {
      ...getHeaderFromParams(params),
      ...requestData
    }
    const data = await apiRequest(
      url,
      reqData,
      true
    )
    if (data.apiResponse === 'failed' || data.statusCode !== 200) {
      return new Promise((resolve) => {
        resolve({ ...data, apiResponseCode: 'failure' })
      })
    }
    return new Promise((resolve) => {
      resolve({ ...data, apiResponseCode: 'success' })
    })
  } catch (error) {
    logError(error)
    return new Promise((resolve) => {
      resolve({ apiResponseCode: 'failure' })
    })
  }
}
export const srBookSlots = async (requestData) => {
  try {
    const url = `${config.covid_vacc_base_url}booking/v2/block_slot/`;
    const params = parseQueryString()
    const reqData = {
      ...getHeaderFromParams(params),
      ...requestData
    }
    const data = await apiRequest(
      url,
      reqData,
      true
    )
    if (data.apiResponse === 'failed' || data.statusCode !== 200) {
      return new Promise((resolve) => {
        resolve({ ...data, apiResponseCode: 'failure' })
      })
    }
    return new Promise((resolve) => {
      resolve({ ...data, apiResponseCode: 'success' })
    })
  } catch (error) {
    logError(error)
    return new Promise((resolve) => {
      resolve({ apiResponseCode: 'failure' })
    })
  }
}

export const srRescheduleAppointment = async (requestData) => {
  try {
    const url = config.covid_vacc_base_url + "booking/v2/reschedule_appointment/";
    const params = parseQueryString()
    const reqData = {
      ...getHeaderFromParams(params),
      ...requestData
    }
    const data = await apiRequest(
      url,
      reqData,
      true
    )
    if (data.apiResponse === 'failed' || data.statusCode !== 200) {
      return new Promise((resolve) => {
        resolve({ ...data, apiResponseCode: 'failure' })
      })
    }
    return new Promise((resolve) => {
      resolve({ ...data, apiResponseCode: 'success' })
    })
  } catch (error) {
    logError(error)
    return new Promise((resolve) => {
      resolve({ apiResponseCode: 'failure' })
    })
  }
}

export const srCreateAppointment = async (requestData) => {
  try {
    const url = config.covid_vacc_base_url + "booking/v2/create_appointment/";
    const params = parseQueryString()
    const reqData = {
      ...getHeaderFromParams(params),
      ...requestData
    }
    const data = await apiRequest(
      url,
      reqData,
      true
    )
    if (data.apiResponse === 'failed' || data.statusCode !== 200) {
      return new Promise((resolve) => {
        resolve({ ...data, apiResponseCode: 'failure' })
      })
    }
    return new Promise((resolve) => {
      resolve({ ...data, apiResponseCode: 'success' })
    })
  } catch (error) {
    logError(error)
    return new Promise((resolve) => {
      resolve({ apiResponseCode: 'failure' })
    })
  }
}

export const srStoreCowinInfo = async (requestData) => {
  const url = config.covid_vacc_base_url + "booking/v2/storecowininfo/"
  const params = parseQueryString()
  const reqData = {
    ...getHeaderFromParams(params),
    ...requestData
  }
  try {
    const data = await apiRequest(
      url,
      reqData,
      true
    )
    return new Promise((resolve) => {
      resolve({ ...data, apiResponseCode: 'success' })
    })
  } catch (error) {
    logError(error)
    return new Promise((resolve, reject) => {
      reject(error)
    })
  }
}